/* Pretty sure the below could be consolidated into fewer line sof code, especially the eventlistener for the animation which is used in 2 places and could probably be 1 shared function or something? Feel free to tidy this file up where possible

The "closing" class is added while the CSS animation for fade in/fade out is running and is then removed, this is the only way to animate the Dialog element and it's backdrop, as by default the Dialog needs to be "display: none" (otherwise it causes layout problems) and we can't transition from display none

If updating please also update any relevant docs here: https://www.notion.so/bravetheskies/Modal-a24d96994cc84472976f052ac3619e9d
*/

import dialogPolyfill from 'dialog-polyfill';

let targetModal = document.querySelectorAll('[data-modal-target]')
let closeModal = document.querySelectorAll('[data-modal-close]')
let modal = document.querySelectorAll('[data-modal]')

if (targetModal) {
  targetModal.forEach(function (element) {
    let target = element.getAttribute("data-modal-target")
    let targets = document.querySelectorAll(target)
    element.addEventListener("click", (event) => {
      targets.forEach(function (e) {
        dialogPolyfill.registerDialog(e);
        e.showModal()
      })
    })
  })
  closeModal.forEach(function (element) {
    element.addEventListener("click", (event) => {
      let dialog = element.closest('dialog')
      dialog.close();
    })
  })
  modal.forEach(function (element) {
    element.addEventListener("click", (e) => {
      let dialog = element.closest('dialog')
      if (e.target === dialog) {
        dialog.close();
      }
    })
  })
}